import { Product } from '../model/product';

export namespace ProductActions {
  export class LoadProducts {
    static readonly type = '[Product] Load Products';
  }

  export class LoadProductByApiName {
    static readonly type = '[Product] Load Product By API Name';
    constructor(public apiName: string) {}
  }

  export class SetSelectedProduct {
    static readonly type = '[Product] Set Selected Product';
    constructor(public selectedProduct: Product) {}
  }

  export class SetCurrentProductIndex {
    static readonly type = '[Product] Set Current Product Index';
    constructor(public index: number) {}
  }

  export class NextProduct {
    static readonly type = '[Product] Next Product';
  }

  export class PreviousProduct {
    static readonly type = '[Product] Previous Product';
  }
}
